import { render, staticRenderFns } from "./NewLocationPostalCodeSelector.vue?vue&type=template&id=58d45903"
import script from "./NewLocationPostalCodeSelector.vue?vue&type=script&lang=js"
export * from "./NewLocationPostalCodeSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports